import styled from 'styled-components'

export const StyledExpandedRateArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  color: #6f7390;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledLabel = styled.span`
  color: #2c2842;
`

export const StyledLimitPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #2c2842;
`

export const StyledRateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledRateDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .boldText {
    font-weight: 600;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0.2px;
  }
`

export const SwitchIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const StyledDiscountedButton = styled.div`
  padding: 0px 4px;
  height: 15px;
  background: linear-gradient(90deg, #ee8fce 8.33%, #d17ede 90.48%);
  border-radius: 20px;
  font-weight: 400;
  font-size: 11px;
  line-height: 140%;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
`
